// extracted by mini-css-extract-plugin
export default {"Title":"DetailItem_Title__tq98U","Value":"DetailItem_Value__extaE","Box":"DetailItem_Box__xBi5i"};